import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { heroTopics } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-brand-paper px-5 pb-14 pt-8 lg:px-8 lg:pb-16 lg:pt-12" data-id="element-91" data-mp="16ocn3gcegksh">
      <div className="mx-auto max-w-4xl text-center" data-id="element-92" data-mp="12nizyp6s7a0n">
        <p className="mx-auto inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-[8px] border border-brand-plum/25 bg-white px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-93" data-mp="1zcqm9zf85n5m">
          {heroTopics.map((topic, index) => <React.Fragment key={topic} data-id="element-94" data-mp="1ld8s14j5thov" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="text-brand-gold" data-id="element-95" data-mp="ewdkwc8o0lre">
                  •
                </span>}
              <span data-id="element-96" data-mp="9x0whn25b6mp">{topic}</span>
            </React.Fragment>)}
        </p>

        <h1 id="hero-heading" className="mt-5 font-display text-[2.5rem] font-bold leading-[1.03] tracking-[-0.015em] text-brand-charcoal sm:text-[3.3rem] lg:text-[4.1rem]" data-id="element-97" data-mp="38ftdb87l9vmz">
          Le système complet prêt à l’emploi <Accent data-id="element-98" data-mp="2zf4yibadfr91">pour les formatrices en maquillage</Accent>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-99" data-mp="34dyce4tklk9q">
          Préparez vos prochains cours en quelques minutes, pas en plusieurs heures. Arrêtez de créer chaque cours de
          zéro.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-100" data-mp="2gp5g2791dael">
          Cours structurés, techniques professionnelles, exercices élèves, évaluations et ressources pédagogiques —
          organisés dans un seul système professionnel.
        </p>
      </div>

      <div className="relative mx-auto mt-8 max-w-[1000px]" data-id="element-101" data-mp="2bpsr9gyltt9d">
        <img src={MOCKUP_URL} alt="Makeup Instructor Ready — les 6 volumes principaux avec des pages réelles sur tablette, ordinateur et téléphone" width={1536} height={1024} loading="eager" decoding="async" className="block w-full object-contain" style={{
        filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
      }} data-id="element-102" data-mp="2bs56vngw3rj9" />
        <p className="absolute -top-2 right-0 rounded-full bg-brand-plum px-4 py-2 font-body text-[11px] font-bold uppercase tracking-[0.14em] text-white shadow-[0_12px_24px_-12px_rgba(59,27,87,0.8)] sm:right-4 sm:top-2 sm:text-[13px]" data-id="element-103" data-mp="3gcl8p8r4anv">
          6 volumes + 5 bonus
        </p>
      </div>

      <CtaBlock label="Oui, je veux le système complet" note="Accès immédiat • Sans abonnement" className="mt-8" data-id="element-104" data-mp="ra4fno002ipw" />
    </section>;
}